module.exports = __webpack_public_path__ + "static/media/WKR2-NEW.d888124e.apng";